import React, { useState, useEffect } from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Cookies from 'universal-cookie';
import './index.css';
import Login from "./Login";
import Signup from "./Signup";
import Logout from "./Logout";
import TestPage from "./TestPage";
import Layout from "./pages/Layout";
import Home from "./pages/Home";
import Customers from "./pages/Customers";
import Inventory from "./pages/Inventory";
import About from "./pages/About";
import TicketMaint from "./pages/TicketMaint";
import CustomerMaint from "./pages/CustomerMaint";
import InventoryMaint from "./pages/InventoryMaint";
import UserMaint from "./pages/UserMaint";
import { GetAttributes, UseLocalStorage, GetAttributesByAssignment } from "./functions";

export default function App() {

  const [localStorageAttributes, setLocalStorageAttributes] = UseLocalStorage('attributes', []);
  const [, setLocalAppVersion] = UseLocalStorage('appversion', '0');
  const [pageCustomer, setPageCustomer] = useState("");
  const [, setIsLoggedIn] = useState(false);

  useEffect(() => {
    document.title = 'Management';
    const doLoad = async () => {
      const cookies = new Cookies();
      let login = cookies.get('login');
      if (login !== undefined) {
        if (localStorageAttributes === undefined || localStorageAttributes === null) {
          let attributes = [];
          attributes = await GetAttributes();
          setLocalStorageAttributes(attributes);
          setLocalAppVersion(process.env.REACT_APP_VERSION);
          console.log('fresh load of attributes complete');

          const customerAttributes = GetAttributesByAssignment('customers', attributes);
          setPageCustomer(customerAttributes.displayplural);
        }
        if (pageCustomer === '' && localStorageAttributes !== undefined && localStorageAttributes != null) {
          const customerAttributes = GetAttributesByAssignment('customers', localStorageAttributes);
          setPageCustomer(customerAttributes.displayplural);
        }
      };
    }
    doLoad();
  });

  // Reload attributes when user returns to the page
  useEffect(() => {
    const handleVisibilityChange = async () => {
      if (!document.hidden) {
        // Page became visible - reload attributes
        const cookies = new Cookies();
        let login = cookies.get('login');
        if (login !== undefined) {
          console.log('Page became visible - reloading attributes');
          let attributes = await GetAttributes();
          setLocalStorageAttributes(attributes);
          setLocalAppVersion(process.env.REACT_APP_VERSION);
          
          const customerAttributes = GetAttributesByAssignment('customers', attributes);
          setPageCustomer(customerAttributes.displayplural);
        }
      }
    };

    document.addEventListener('visibilitychange', handleVisibilityChange);
    
    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, [setLocalStorageAttributes, setLocalAppVersion, setPageCustomer]);

  // Check login status periodically
  useEffect(() => {
    const checkLoginStatus = () => {
      const cookies = new Cookies();
      const login = cookies.get('login');
      setIsLoggedIn(!!login);
    };

    // Check immediately
    checkLoginStatus();

    // Check every second for login status changes
    const interval = setInterval(checkLoginStatus, 1000);

    return () => clearInterval(interval);
  }, []);



  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route index element={<Home />} />
          <Route path="testpage" element={<TestPage />} />
          <Route path="Customers" element={<Customers />} />
          <Route path="Inventory" element={<Inventory />} />
          <Route path="about" element={<About />} />
          <Route path="logout" element={<Logout />} />
          <Route path="login" element={<Login />} />
          <Route path="signup" element={<Signup />} />
          <Route path="usermaint" element={<UserMaint />} />
          <Route path="ticketmaint" element={<TicketMaint />} />
          <Route path="customermaint" element={<CustomerMaint />} />
          <Route path="inventorymaint" element={<InventoryMaint />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<App />);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();










// import React, { createContext, useContext, useState } from "react";

// const PageContext = createContext();

// const PageProvider = ({ children }) => {
//   const [currentPage, setCurrentPage] = useState("Home");
//   return (
//     <PageContext.Provider value={{ currentPage, setCurrentPage }}>
//       {children}
//     </PageContext.Provider>
//   );
// };

// const Layout = () => {
//   const { currentPage } = useContext(PageContext);
//   return <h1>Current Layout: {currentPage}</h1>;
// };

// const PageButtons = () => {
//   const { setCurrentPage } = useContext(PageContext);
//   return (
//     <div>
//       <button onClick={() => setCurrentPage("Home")}>Home</button>
//       <button onClick={() => setCurrentPage("About")}>About</button>
//       <button onClick={() => setCurrentPage("Contact")}>Contact</button>
//     </div>
//   );
// };

// export default function App() {
//   return (
//   <PageProvider>
//     <Layout />
//     <PageButtons />
//   </PageProvider>
// );
// }

// const root = ReactDOM.createRoot(document.getElementById('root'));
// root.render(<App />);
